export default __webpack_public_path__ + "static/media/DorrieLovelace.de3071d0.png";